// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const growlithe_hisui: PokeData = {
  "id": 10229,
  "name": "growlithe-hisui",
  "height": 8,
  "weight": 227,
  "base_experience": 70,
  "types": [
    PokeType.FIRE,
    PokeType.ROCK
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "leer",
    "bite",
    "roar",
    "ember",
    "flamethrower",
    "rock-slide",
    "flame-wheel",
    "reversal",
    "crunch",
    "helping-hand",
    "howl",
    "flare-blitz",
    "fire-fang",
    "retaliate"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "rock-slide",
    "crunch",
    "flare-blitz",
    "fire-fang",
    "boulder_bash",
    "sunny-day",
    "magma-storm",
    "fire-spin"
  ],
  "evolution_chain": {
    "id": 25,
    "item": null,
    "species": [
      {
        "name": "growlithe",
        "order": 63,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "arcanine",
        "order": 64,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 58,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 108,
    "speed": 110,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
